import './CorrectUIDAssetType.scss'

import { DropDownList } from '@progress/kendo-react-dropdowns'
import React, { useEffect, useState } from 'react'
import Alert from 'react-popup-alert'

import {
    AssetCategory,
    AssetType,
    fetchAssetByAssetId,
    fetchAssetCategories,
    fetchAssetTypes,
    fetchPermissions,
    fetchTagMaster,
    fetchUpdateTagMasterAssetType,
    Tag,
} from '../../features/forms/formsAPI'
import { fetchGetCurrentUser } from '../../features/meta/metaAPI'

export const CorrectUIDAssetType = () => {
    const [perms, setPerms] = useState<boolean>(true)

    useEffect(() => {
        const checkPermissions = async () => {
            const user = await fetchGetCurrentUser()
            const permissions = await fetchPermissions({
                Company: user.CompanyCode,
                Username: user.Username,
                Domain: 'ORDERPROCESSING',
                Ability: 'CORRECT UID ASSET TYPE',
            })
            if (permissions === '') {
                setPerms(true)
            } else {
                setPerms(false)
            }
        }
        if (!window.location.href.includes('localhost')) checkPermissions()
    }, [])

    if (perms) {
        return <HasPermissions />
    } else {
        return <NoPermissions />
    }
}

export const HasPermissions = () => {
    /**
     * Tag ID
     */
    const [tagUIDs, setTagUIDs] = useState<string>('')
    const [tagError, setTagError] = useState<boolean>(false)
    const [tags, setTags] = useState<(Tag | null | undefined)[]>()
    const setTagErrorTrue = () => {
        setTagError(true)
    }

    // Handle when user presses enter key on tag UID field
    const handleTagUIDKeyDown = (event: any) => {
        if (event.key === 'Enter') {
            event.target.blur()
        }
    }

    // Handle when user leaves the tag UID field
    const handleTagUIDBlur = async (event: any) => {
        const allTagsSplit: string[] = event.target.value
            .replaceAll(' ', ',')
            .replace(/,+/g, ',')
            .split(',')

        const allTags: string[] = allTagsSplit.filter((v) => v !== '')
        let errorExists = false

        // Waits for all API calls to finish using Promise.all
        const tempTags = await Promise.all(
            allTags.map(async (tempTag) => {
                if (tempTag) {
                    const response = await fetchTagMaster(parseInt(tempTag))
                    if (!response) {
                        setTagErrorTrue()
                        errorExists = true
                    }
                    return response
                }
            })
        )

        // Make sure not empty array and no errors from API call
        if (tempTags[0] && tempTags.length > 0 && !errorExists) {
            setTagUIDs(allTagsSplit.join(', '))
            setTags(tempTags)

            if (tempTags.length === 1) {
                const asset = await fetchAssetByAssetId(tempTags[0].CustomerAssetType)
                setCurrentType(asset.CategoryName + ' / ' + asset.AssetTypeName)
            } else if (tempTags.length > 1) {
                setCurrentType('Multiple')
            } else {
                setCurrentType('')
            }
        } else {
            setTagUIDs('')
            setTags(undefined)
            setCurrentType('')
        }
    }

    /**
     * Current Type
     */
    const [currentType, setCurrentType] = useState<string>('')

    /**
     * Asset Categories
     */
    const [assetCategories, setAssetCategories] = useState<AssetCategory[]>()
    const [assetCategoryNames, setAssetCategoryNames] = useState<string[]>([])
    const [selectedCategory, setSelectedCategory] = useState<string>('Select a category')

    const handleCategoryChange = async (event: any) => {
        setSelectedCategory(event.value)
        setSelectedType('-- Select One --')

        let id = 0
        assetCategories?.map((asset: AssetCategory) => {
            if (asset.Name === event.value) {
                id = asset.ID
            }
        })

        const assets = await fetchAssetTypes(id)
        setAssetTypes(assets)
        const tempList = assets.map((asset: AssetType) => {
            return asset.Name
        })
        setAssetTypeNames(tempList)
    }

    async function getCategories() {
        const categoryJson = await fetchAssetCategories()

        if (categoryJson && categoryJson.length > 0) {
            setAssetCategories(categoryJson)
            const tempList = categoryJson.map((asset: AssetCategory) => {
                return asset.Name
            })
            setAssetCategoryNames(tempList)
        }
    }

    // Fetch to get the asset categories on load
    useEffect(() => {
        getCategories()
    }, [])

    /**
     * Asset Types
     */
    const [assetTypes, setAssetTypes] = useState<AssetType[]>()
    const [assetTypeNames, setAssetTypeNames] = useState<string[]>()
    const [selectedType, setSelectedType] = useState<string>('-- Select One --')

    const handleTypeChange = async (event: any) => {
        setSelectedType(event.value)
    }

    // Alert system
    const [alert, setAlert] = React.useState({
        type: 'error',
        text: 'This is a alert message',
        show: false,
    })

    function onCloseAlert() {
        if (alert.type === 'success') {
            window.location.reload()
        }
        setAlert({
            type: '',
            text: '',
            show: false,
        })
    }

    function onShowAlert(type: string, text: string) {
        setAlert({
            type: type,
            text: text,
            show: true,
        })
    }

    return (
        <>
            <div className="correctUIDAssetType">
                <div
                    style={{
                        textAlign: 'center',
                        marginBottom: 10,
                        fontSize: 18,
                        fontWeight: 700,
                    }}
                >
                    Correct UID Asset Type
                </div>

                <div className="flexBox">
                    <div className="labelBold">Tag UID(s)</div>
                    <div>
                        <input
                            type="text"
                            placeholder="Enter tag UID(s)"
                            value={tagUIDs}
                            onChange={(event: any) => {
                                const value = event.target.value.replace(/[^0-9 ,]/, '')
                                // const arr1 = value.trim().split(",");
                                setTagUIDs(value)
                            }}
                            onClick={() => {
                                setTagError(false)
                            }}
                            onKeyDown={handleTagUIDKeyDown}
                            onBlur={handleTagUIDBlur}
                            // pattern="^$|[0-9]{0,3}"
                            style={{ marginLeft: 1, width: 370, height: 25 }}
                        />
                        {tagError && (
                            <div style={{ color: 'red', position: 'absolute' }}>
                                Invalid Tag UID!
                            </div>
                        )}
                    </div>
                </div>

                <div className="flexBox">
                    <div className="labelBold">Current Type</div>
                    <div>{currentType}</div>
                </div>

                <div className="flexBox">
                    <div className="labelBold">New Type</div>
                    <div className="labelBoldExtended">Category</div>
                    <div className="labelBoldExtended">Asset Type</div>
                </div>

                <div className="flexBox">
                    <div className="labelBold" />
                    <div className="labelBoldExtended">
                        <DropDownList
                            className="inputContainer"
                            style={{
                                width: 180,
                                height: 32,
                            }}
                            data={assetCategoryNames}
                            value={selectedCategory}
                            popupSettings={{
                                height: 90,

                                animate: false,
                            }}
                            defaultItem={'Select a category'}
                            onChange={handleCategoryChange}
                        />
                    </div>
                    <div className="labelBoldExtended">
                        <DropDownList
                            className="inputContainer"
                            style={{
                                width: 180,
                                height: 32,
                            }}
                            data={assetTypeNames}
                            value={selectedType}
                            popupSettings={{
                                height: 90,
                                animate: false,
                            }}
                            disabled={selectedCategory === 'Select a category' ? true : false}
                            defaultItem={'-- Select One --'}
                            onChange={handleTypeChange}
                        />
                    </div>
                </div>

                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginTop: 35,
                    }}
                >
                    <button
                        className="changeButton"
                        style={{ width: 75 }}
                        onClick={async () => {
                            if (!tagUIDs) {
                                // window.alert("Enter a Tag UID!");
                                onShowAlert('warning', 'Enter a Tag UID!')
                            } else if (selectedCategory === 'Select a category') {
                                // window.alert("Select a category!");
                                onShowAlert('warning', 'Select a category!')
                            } else if (selectedType === '-- Select One --') {
                                // window.alert("Select an asset type!");
                                onShowAlert('warning', 'Select an asset type!')
                            } else {
                                const allTags: string[] = tagUIDs.replaceAll(' ', '').split(',')
                                const allTagsNum: number[] = allTags.map((x) => parseInt(x))
                                let id = 0
                                assetTypes?.map((asset: AssetType) => {
                                    if (asset.Name === selectedType) {
                                        id = asset.ID
                                    }
                                })
                                const updated = await fetchUpdateTagMasterAssetType(allTagsNum, id)

                                if (updated) {
                                    // window.alert("Change completed successfully");
                                    onShowAlert('success', 'Change completed successfully')
                                } else {
                                    // window.alert("Error updating!");
                                    onShowAlert('error', 'Error updating!')
                                }
                            }
                        }}
                    >
                        Change
                    </button>
                </div>
            </div>
            <Alert
                header={''}
                btnText={'Close'}
                text={alert.text}
                type={alert.type}
                show={alert.show}
                onClosePress={onCloseAlert}
                pressCloseOnOutsideClick={true}
                showBorderBottom={true}
                alertStyles={{}}
                headerStyles={{}}
                textStyles={{}}
                buttonStyles={{}}
            />
        </>
    )
}

export const NoPermissions = () => {
    return (
        <div className="correctUIDAssetType">
            <div
                style={{
                    display: 'flex',
                    height: '100vh',
                    justifyContent: 'center',
                    alignItems: 'center',
                    fontWeight: 700,
                    fontSize: 18,
                    padding: 15,
                }}
            >
                Only users with the ORDERPROCESSING/Correct Asset Type permission may use this
                utility.
            </div>
        </div>
    )
}
